<div class="app-content">
  <slb-card-group>
    <mat-card class="card">
      <div style="display: none"></div>
      <div class="card-img" style="background-image: url(&quot;https://p4d.csi.cloud.slb-ds.com/ccm/catalog/v1/icons/EPPL-TO-SUBU&quot;)">
      </div>
      <mat-card-header>
        <mat-card-title>Coiled Tubing Design Software</mat-card-title>
      </mat-card-header>
      <mat-card-actions>
        @if (appConfigService.coilCadeUrl) {
          <a slb-button [href]="appConfigService.coilCadeUrl">Go</a>
        } @else {
          <button slb-button disabled="true">Go</button>
          <mat-icon class="action-icon" svgIcon="help" aria-hidden="true" matTooltip="CoilCADE X is currently under development"></mat-icon>
        }
      </mat-card-actions>
    </mat-card>

    <mat-card class="card">
      <div style="display: none"></div>
      <div class="card-img" style="background-image: url(&quot;https://p4d.csi.cloud.slb-ds.com/ccm/catalog/v1/icons/FDPL-TO-SUBU&quot;)">
      </div>
      <mat-card-header>
        <mat-card-title>Coiled Tubing Acquisition and Monitoring Software</mat-card-title>
      </mat-card-header>
      <mat-card-actions>
        <button slb-button disabled="true">Go</button>
        <mat-icon class="action-icon" svgIcon="help" aria-hidden="true" matTooltip="CoilCAT X module is not implemented yet"></mat-icon>
      </mat-card-actions>
    </mat-card>

    <mat-card class="card">
      <div style="display: none"></div>
      <div class="card-img" style="background-image: url(&quot;https://p4d.csi.cloud.slb-ds.com/ccm/catalog/v1/icons/PWOA-TO-SUBU&quot;)">
      </div>
      <mat-card-header>
        <mat-card-title>Coiled Tubing Analytics</mat-card-title>
      </mat-card-header>
      <mat-card-actions>
        <button slb-button routerLink="/dashboard/Dashboard">Go</button>
      </mat-card-actions>
    </mat-card>
  </slb-card-group>
</div>
